import {
  buildEditPostInitialState,
  buildEditPostPayload,
} from "./editPostPayloadBuilder";

const normalizeComparableValue = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeComparableValue(item));
  }

  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((normalized, key) => {
        normalized[key] = normalizeComparableValue(value[key]);
        return normalized;
      }, {});
  }

  return value == null ? "" : value;
};

export function hasEditPostPayloadChanged(post, payload) {
  const initialPayload = buildEditPostPayload(
    post,
    buildEditPostInitialState(post)
  );

  return (
    JSON.stringify(normalizeComparableValue(payload)) !==
    JSON.stringify(normalizeComparableValue(initialPayload))
  );
}
